import axios from 'axios';

export const isNetworkError = (error: unknown) =>
  axios.isAxiosError(error) && !error.response;
